<script>
export default {
  props: ['areas', 'initWithDefaultArea'],
  data() {
    return {
      selected: '',
      defaultArea: '',
      options: this.areas ? this.areas.options : '',
      title: this.areas ? this.areas.title : '',
    };
  },
  async created() {
    await import(
      /* webpackChunkName: "forms" */ '../../../static/js/loaders/forms.js'
    );
  },
  methods: {
    onChange(event) {
      this.$emit(
        'update-request',
        'Area', // the key
        this.selected, // the value
        false, // is not a facet
        false // do not add to activeFilters
      );
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.defaultArea = this.initWithDefaultArea;
    });
  },
};
</script>

<template>
  <select
    :id="this.title"
    :title="this.title"
    class="select-css form-control enable-forms"
    v-model="selected"
    @change="onChange($event)">
    <option disabled value="">{{ this.title }}</option>
    <option
      v-for="(item, index) in this.options"
      :value="item.value"
      :key="index">
      {{ item.text }}
    </option>
  </select>
</template>
